import * as React from 'react';
import { SVGProps } from 'react';

const IconArrowUpSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m8 6.406-4.297 4.297-1.414-1.414L8 3.577l5.711 5.712-1.414 1.414L8 6.406Z"
    />
  </svg>
);
export default IconArrowUpSizeS;
